import { Typography } from "@material-ui/core";
import React from "react";
import { Spacer, useThemeSettings } from "@internal/plugin-utilities";
import { radiatorDarkTheme, radiatorLightTheme } from "@internal/plugin-theme";
import { makeStyles } from "@material-ui/styles";
import { SectionHeader } from "../TeamBreakdown/SectionHeader/SectionHeader";
import { Progress } from "@backstage/core-components";
import { InformationTooltip } from "../InformationTooltip";

const useStyles = makeStyles(() => ({
  ul: {
    margin: "0 auto",
    width: "50%",
    listStyle: "none",
    textAlign: "center",
    padding: 0,
  },
  li: {
    padding: "20px 0",
    borderRadius: "5px",
  },
}));

interface Props {
  wins: any;
  loading: boolean;
}

export const WinsSection: React.FC<Props> = ({
  wins,
  loading,
}): JSX.Element => {
  const classes = useStyles();

  const tooltip = (
    <>
      <Typography variant="h5">Wins for the Week</Typography>
      <div>
        This sections displays any "wins" for the previous week. This is a
        manually configured field that can be accessed by going to the edit
        screen (/ops-review/edit) and selecting the date you'd like to add your
        wins to.
      </div>
    </>
  );

  const header = (
    <div style={{ textAlign: "center" }}>
      <SectionHeader title="🥳 Wins for the Week! 🎉" />
      <InformationTooltip title={tooltip} />
      <Spacer variant="double" />
    </div>
  );

  const theme =
    useThemeSettings() === "dark" ? radiatorDarkTheme : radiatorLightTheme;

  if (!wins || (wins && wins.length === 0)) {
    return (
      <div>
        {header}
        <ul className={classes.ul}>
          <li>
            <Typography variant="h6">
              No wins announced for this week... 😢🐼
            </Typography>
          </li>
        </ul>
      </div>
    );
  }

  return (
    <div>
      {header}
      {loading ? (
        <Progress />
      ) : (
        <ul className={classes.ul}>
          {wins &&
            wins.map((w: any, idx: number) => {
              return (
                <li
                  className={classes.li}
                  style={{
                    backgroundColor:
                      idx % 2
                        ? theme.palette.background.default
                        : theme.palette.background.paper,
                  }}
                  key={idx}
                >
                  <Typography variant="h6">{w}</Typography>
                </li>
              );
            })}
        </ul>
      )}
    </div>
  );
};
